import React from 'react'
import {TimeValue} from "../../../../../gd/types/datetime"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";

type State = {
    initialPropsValue   : any, // required to check if currentOption update needed on props changed
    currentValue        : any,
    showPopover         : boolean
}

const debug = false
// const debug = "FieldTimeOfDay_FormView"

export default class FieldTimeOfDay_FormElementView extends React.Component<FieldFormElementViewProps,State> {

    public previousValue        : any

    constructor(props:FieldFormElementViewProps) {
        super(props);

        const value = props.field.getViewValue(props.model)
        debug && console.log(debug, "constructor() value=", value)

        this.state = {
            initialPropsValue   : value, // required to check if currentValue update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    onValueChange = (newValue:any, hidePopover: boolean = true) => {
        this.previousValue = this.state.currentValue;

        this.setState({
            currentValue: newValue
        }, () => {
            if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            if (hidePopover) this.hidePopover()
        });
    }

    setValue = (value:TimeValue) => {
        this.hidePopover()

        if (!value) return this.resetValue()

        const result: Moment = this.state.initialPropsValue ? this.state.initialPropsValue as Moment : moment()
        result.hours(value.hours)
        result.minutes(value.minutes)
        result.seconds(0)
        result.milliseconds(0)

        this.onValueChange(result);
        // this.props.onChange && this.props.onChange(result)
    }

    resetValue = () => {
        this.hidePopover()
        this.onValueChange(null);
        // this.props.onChange && this.props.onChange(null)
    }

    onOptionClick = (option: Option) => {
        this.setValue(option.value)
    }

    render() {
        const {field} = this.props

        const classes = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        })

        // need check value because of none
        if (this.state.currentValue) {
            return (
                <field.components.FormValueNotEmpty className   = {classes}
                                                    field       = {field}
                                                    options     = {this.props.options}
                                                    onReset     = {this.resetValue}
                                                    value       = {this.state.currentValue}
                                                    disabled    = {this.props.disabled}
                                                    onClick     = {this.showPopover}>
                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props} value={this.state.currentValue} parent={this} />
                    }
                </field.components.FormValueNotEmpty>
            )
        } else {
            return (
                <field.components.FormValueEmpty className = {classes}
                                                 field     = {field}
                                                 options   = {this.props.options}
                                                 onClick   = {this.showPopover}
                                                 disabled  = {this.props.disabled}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} value={this.state.currentValue} parent={this} />}
                </field.components.FormValueEmpty>
            )
        }
    }
}
